import { ContentsCollapsibleWeb } from '@components/enrollments/courses/course_contents/ContentsCollapsibleWeb'
import ContentsModal from '@components/enrollments/courses/course_contents/ContentsModal'
import { CourseContentConsumption } from '@components/enrollments/courses/course_contents/CourseContentConsumption'
import { CourseContentsProvider } from '@contexts/CourseContentsContext'
import { CourseProvider } from '@contexts/CourseContext'
import { EnrollmentProvider } from '@contexts/EnrollmentContext'
import { ModulesProvider } from '@contexts/ModulesContext'
import { useMediaSize } from '@hooks/useMediaSize'
import { AppLayout } from '@layouts/AppLayout'
import { router } from 'expo-router'
import { isWeb, View } from 'tamagui'

export default function CourseContents() {
  const displayModal = !isWeb

  const mediaSize = useMediaSize()
  const isMobile = mediaSize === 'xs' || mediaSize === 'sm'

  return (
    <CourseContentsProvider>
      <CourseProvider>
        <EnrollmentProvider>
          <CourseContentsProvider>
            <ModulesProvider>
              <AppLayout
                backRoute={{
                  label: 'Voltar',
                  back: () => router.back(),
                }}
                hasFooter={false}
                hasPaddingBottom={false}
                hasBackButton={isMobile}
              >
                <>
                  <View flex={1} position="relative">
                    <CourseContentConsumption />
                    {displayModal && <ContentsModal />}
                  </View>
                  {!displayModal && isMobile && (
                    <ContentsCollapsibleWeb type="bottomFixed" />
                  )}
                </>
              </AppLayout>
            </ModulesProvider>
          </CourseContentsProvider>
        </EnrollmentProvider>
      </CourseProvider>
    </CourseContentsProvider>
  )
}
